module.exports = __webpack_public_path__ + "img/page-29.d83945ef.jpg";